module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-steak@2x-2a6e20ee0c698be7d23f8c7ece7d8751.png";